import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const BatteryCard = () => {
useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const canView  = hasPermission("Battery Card", "view");
      const canEntry = hasPermission("Battery Card", "entry");
      const canEdit  = hasPermission("Battery Card", "edit");
      const canDel   = hasPermission("Battery Card", "del");
    


  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_battery_card_api`);
      console.log("API Response:", response.data.vehicles);
      setData(response.data.vehicles);
      setFilteredData(response.data.vehicles);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoading(false);
    }
  
}
fetchData();
}, []);

const handleCheckboxChange = (id) => {
    const numericId = Number(id); // ensure numeric
    setSelectedIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((i) => i !== numericId)
        : [...prev, numericId]
    );
  };
    

  const handleBulkDelete = () => {
    if (selectedIds.length === 0) {
      Swal.fire("Warning", "No items selected for deletion.", "warning");
      return;
    }
  
    console.log("Selected IDs to delete:", selectedIds);
  
    Swal.fire({
      title: `Delete ${selectedIds.length} item(s)?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const deleteRequests = selectedIds.map((id) => {
            console.log(`Sending DELETE request for ID: ${id}`);
            return axios.delete(`https://rfs2.infraconsoft.net.in/api/battery_delet_api/${id}`);
          });
  
          await Promise.all(deleteRequests);
  
          // Remove from UI
          const updatedData = data.filter((item) => !selectedIds.includes(item.No));
          setData(updatedData);
          setFilteredData(updatedData);
          setSelectedIds([]);
  
          Swal.fire("Deleted!", "Selected records have been deleted.", "success");
          window.location.reload();
        } catch (error) {
          console.error("Bulk delete error:", error);
          if (error.response) {
            console.error("Server response:", error.response.data);
          }
          Swal.fire("Error", "Failed to delete selected records.", "error");
        }
      }
    });
  };

 
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.battery_code || "").toLowerCase().includes(term) ||
    String(item.battery_make || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Batterycard View </h2>
          <Time />
        </section>


        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/add_batterycard`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Battery Code & Make"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
            <tr>
            <th>S.No</th>
                <th>Battery Code</th>
                <th>Battery Make</th>
                <th>Battery Type</th>
                <th>Expected Life</th>
                <th>Purchased From</th>
{canEdit && (
                <th>Edit</th>
)}
{canDel && (
                <th>
                <button onClick={handleBulkDelete} className="btn btn-danger btn-sm ms-2">
        Delete
      </button>
                </th>
)}
               
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                                            <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.battery_code}</td>                    
                    <td>{item.battery_make}</td>                    
                    <td>{item.battery_type}</td>                    
                    <td>{item.life}</td>    
                    <td>{item.purchase_from}</td>    
                    {canEdit && (
                    <td>
                      <Link to={`/edit_batterycard/${item.No}`}>Edit</Link>
                    </td>
                    )}
                    {canDel && (
                    <td>
              <input
                type="checkbox"
                checked={selectedIds.includes(Number(item.No))}
                onChange={() => handleCheckboxChange(item.No)}
              />
            </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default BatteryCard;
